import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useToasts } from "react-toast-notifications";
import saleTeamsService from "../../services/saleTeamsService";

export const useListSaleTeams = ({ params }) => {
  return useQuery(
    ["listSaleTeams", params],
    () => saleTeamsService.listSaleTeams({ params }),
    {
      enabled: params?.run || false,
      keepPreviousData: true,
      select: response => {
        const { data } = response;
        const items = data.items || [];
        const hasNotConfigured = items.some(
          item => !item.hub || !item.hub.name
        );

        let finalList = items;
        if (hasNotConfigured) {
          finalList = items.slice().sort((a, b) => {
            const aNotConfigured = !a.hub || !a.hub.name;
            const bNotConfigured = !b.hub || !b.hub.name;
            if (aNotConfigured && !bNotConfigured) return -1;
            if (!aNotConfigured && bNotConfigured) return 1;
            return 0;
          });
        } else {
          finalList = items.slice().sort((a, b) => {
            const aDate = new Date(
              a.updated_at || a.maker_date || a.checker_date
            );
            const bDate = new Date(
              b.updated_at || b.maker_date || b.checker_date
            );
            return bDate - aDate;
          });
        }
        return {
          items: finalList,
          totalCount: data._meta ? data._meta.totalCount : items.length,
        };
      },
    }
  );
};

export const useDetailSaleTeams = ({ saleTeamsId, enabled = true }) => {
  return useQuery(
    ["detailSaleTeams", saleTeamsId],
    () => saleTeamsService.detailSaleTeams({ saleTeamsId }),
    {
      enabled: enabled && !!saleTeamsId,
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

export const useUpdateSaleTeams = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["saleTeams"]);
  const { addToast } = useToasts();

  return useMutation(
    ({ saleTeamsId, data }) =>
      saleTeamsService.updateSaleTeams({ saleTeamsId, data }),
    {
      retry: 0,
      onSuccess: data => {
        addToast(
          t("message.update", {
            target: t("sale_teams"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        queryClient.invalidateQueries("listSaleTeams");
        queryClient.invalidateQueries("detailSaleTeams");
        if (typeof onSuccess === "function") {
          onSuccess(data);
        }
      },
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.update", {
                target: t("sale_teams"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
    }
  );
};
